import React , {useEffect, useState} from "react"

import { Button, Col, FormGroup, InputGroup, Label, Row } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import Flatpickr from "react-flatpickr"
import { connect } from "react-redux";
import Select from "react-select"
import makeAnimated from "react-select/animated"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";
import LatestTransactions from "./latest-transactions";
import LatestOrders from "./latest-orders";
import * as url from "./../../helpers/url_helper"
import moment from "moment";
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { array } from "prop-types";

const Dashboard = (props) => {

  document.title = "Tableau de bord: UE DIGITAL";

  const breadcrumbItems = [
    { title: "UE DIGITAL", link: "#" },
    { title: "Tableau de bord", link: "#" }
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Tableau de Bord Guichet', breadcrumbItems)
    loadBoard()
    loadAgences()
    lastOperations()
    lastBordereau()
    loadBordByDelay()
    loadStatByDates()
  }, [])

  const loadBoard=()=> {
    fetch(url.BACKEND_URL+"/bordereau/board?start="+startDate+"&end="+endDate+"&etp="+userJson.usAgence.agEtp.etpId+"&agexp="+agexp+"&agdest="+dest, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(req.originalUrl);
      if (responseJson.status==200) { 
        setAllOp(responseJson.data.allOp);
        setPendOp(responseJson.data.pendOp);
        setSendOp(responseJson.data.sendOp);
        setLateOp(responseJson.data.lateOp);
        setAllBord(responseJson.data.allBord);
        setPendBord(responseJson.data.pendBord);
        setSendBord(responseJson.data.sendBord);
        setLateBord(responseJson.data.lateBord);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadBordByDelay=()=> {
    fetch(url.BACKEND_URL+"/bordereau/count-by-delay?etp="+userJson.usAgence.agEtp.etpId, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setSeries([{ name: 'Series A', data: [responseJson.data.pendSince2h, responseJson.data.pendSince4h, responseJson.data.pendSince6h, responseJson.data.pendSinceOther]}]);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const lastOperations=()=> {
    fetch(url.BACKEND_URL+"/operation?start=2024-08-01&end="+endDate+"&size=5&user="+userJson.usId+"&agdest="+dest, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setLastOp(responseJson.data)
    } else {  }
    }) .catch((error) => {  });
  };
  
  const lastBordereau=()=> {
    fetch(url.BACKEND_URL+"/bordereau?start=2024-08-01&end="+endDate+"&size=5&user="+userJson.usId+"&agdest="+dest, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { //console.log(responseJson.data);
      if (responseJson.status==200) { 
        setLastBord(responseJson.data)
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadAgences= ()=> {
    let agencesArray= [{label: "Toutes les agences", value: ''}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { //console.log(userJson.usId);
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadStatByDates= ()=> {
    let axeArray= []; let valArray= [];
    fetch(url.BACKEND_URL+"/operation/stat-by-dates?user="+userJson.usId, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        axeArray=[
          ...axeArray,
          ...responseJson.data.map(item=>(item.date ))]; 
        
        valArray=[
          ...valArray,
          ...responseJson.data.map(item=>(item.count))]; 
        setValDaylyStat(valArray);
        setAxeDaylyStat(axeArray);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const userJson= JSON.parse(localStorage.getItem("user"));
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [allOp, setAllOp] = useState(0);
  const [pendOp, setPendOp] = useState(0);
  const [sendOp, setSendOp] = useState(0);
  const [lateOp, setLateOp] = useState(0);
  const [allBord, setAllBord] = useState(0);
  const [pendBord, setPendBord] = useState(0);
  const [sendBord, setSendBord] = useState(0);
  const [lateBord, setLateBord] = useState(0);
  const [agences, setAgences] = useState([]);
  const [dest, setDest] = useState('');
  const [agexp, setAgexp] = useState('');
  const [selectedDest, setSelectedDest] = useState(null);
  const [selectedOrigine, setSelectedOrigine] = useState(null);
  const [lastOp, setLastOp] = useState([]);
  const [lastBord, setLastBord] = useState([]);
  const [series, setSeries]= useState([{ name: 'Series A', data: [0, 0, 0, 0]}]);
  const optionGroup = [ { options: agences } ]
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const handleOrigine= (event)=>{ setSelectedOrigine(event); setAgexp(event.value); }
  const [axeDaylyStat, setAxeDaylyStat]= useState([]);
  const [valDaylyStat, setValDaylyStat]= useState([]);
  

  const reports = [
    { title: "Bordereau Créés", message: "Bordereau créés", iconClass: "cube-outline", total: allBord, average: "+11%", badgecolor: "info" },
    { title: "Bordereau en attente", message: "Bordereau en attente", iconClass: "buffer", total: pendBord, average: "-29%", badgecolor: "danger" },
    { title: "Bordereau en transit", message: "Bordereau en transit", iconClass: "buffer", total: sendBord, average: "-29%", badgecolor: "danger" },
    { title: "Bordereau en retard", message: "Retard d'expédition (24h)", iconClass: "buffer", total: lateBord, average: "-29%", badgecolor: "danger" },
    { title: "Colis créés", message: "Colis créés", iconClass: "buffer", total: allOp, average: "-29%", badgecolor: "danger" },
    { title: "Colis en attente", message: "En attente", iconClass: "message", total: pendOp, average: "0%", badgecolor: "warning" },
    { title: "Colis en transit", message: "Colis en transit", iconClass: "briefcase-check", total: sendOp, average: "+89%", badgecolor: "info" },
    { title: "Colis en retard", message: "Retard d'expédition (24h)", iconClass: "briefcase-check", total: lateOp, average: "+89%", badgecolor: "info" },
  ]

  const columns = {
    columns: [
        ['En attente', pendBord],
        ['En transit', sendBord],
        ['En retard', lateBord]
      ],
    type: 'donut',
  };
  return (
    <React.Fragment>
      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="2">
          <div className="mb-3">
            <Label>Origine</Label>
            <Select
              value={selectedOrigine}
              onChange={handleOrigine}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mb-3">
            <Label>Destination</Label>
            <Select
              value={selectedDest}
              onChange={handleDestination}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={loadBoard} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
      {/*mimi widgets */}
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings 
            columns={columns}
           />
        </Col>

        <Col xl="5">
          {/* Email sent */}
          <EmailSent info={series} />
        </Col>

        <Col xl="4">
          <MonthlyEarnings2 infos={{ axe: axeDaylyStat, value:  valDaylyStat}} />
        </Col>

      </Row>

      <Row>
        <Col xl="6">
          {/* latest transactions */}
          <LatestTransactions latest={lastOp} />
        </Col>

        <Col xl="6">
          {/* latest orders */}
          <LatestOrders latest={lastBord} />
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);